import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../data/stats';
export function StatsSection() {
  return <section className="py-16 md:py-20 px-4 bg-ivory" data-id="element-272" data-mp="q5bm6s5vdoi7">
      <div className="max-w-5xl mx-auto" data-id="element-273" data-mp="14swrmsq7vzta">
        <h2 className="text-2xl md:text-3xl font-display font-bold uppercase text-charcoal text-center mb-10" data-id="element-274" data-mp="14tomu2fwjvj1">
          Numbers worth <span className="text-orange" data-id="element-275" data-mp="1003k5x3d6ddi">remembering</span>
        </h2>
        <dl className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-276" data-mp="1dsa0pkafimdh">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.28,
          delay: index % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-sand-deep rounded-2xl px-5 py-6 text-center" data-id="element-277" data-mp="18tp21patsar5" data-mpi={index}>
              <dt className="sr-only" data-id="element-278" data-mp="sgdlcvs893ft">{stat.label}</dt>
              <dd data-id="element-279" data-mp="sdhpdczxwou0">
                <span className="block text-4xl md:text-5xl font-display font-bold text-orange leading-none mb-2" data-id="element-280" data-mp="wh5xbwshhmfs">
                  {stat.value}
                </span>
                <span className="block text-xs md:text-sm uppercase tracking-wide text-warmgray font-medium" data-id="element-281" data-mp="11exub57zjyqu">
                  {stat.label}
                </span>
              </dd>
            </motion.div>)}
        </dl>
      </div>
    </section>;
}